import * as React from "react";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { AwsNodePools } from "./aws/nodePools";
import { AzureNodePools } from "./azure/nodePools";
import { DigitalOceanNodePools } from "./digitalocean/nodePools";
import { EphemeralNodePools } from "./ephemeral/nodePools";
import { GcpNodePools } from "./gcp/nodePools";
import { GenericNodePools } from "./generic/nodePools";
import { HetznerNodePools } from "./hetzner/nodePools";
import { LambdalabsNodePools } from "./lambdalabs/nodePools";
import { LinodeNodePools } from "./linode/nodePools";
import { OblivusNodePools } from "./oblivus/nodePools";
import { PaperspaceNodePools } from "./paperspace/nodePools";
import { TritonNodePools } from "./triton/nodePools";

interface Props {}
export const NodePools: React.FC<Props> = ({}) => {
  const provider = useCpFormValue(`provider`);

  if (provider === "aws") {
    return <AwsNodePools />;
  }

  if (provider === "azure") {
    return <AzureNodePools />;
  }

  if (provider === "digitalocean") {
    return <DigitalOceanNodePools />;
  }

  if (provider === "ephemeral") {
    return <EphemeralNodePools />;
  }

  if (provider === "gcp") {
    return <GcpNodePools />;
  }

  if (provider === "generic") {
    return <GenericNodePools />;
  }

  if (provider === "hetzner") {
    return <HetznerNodePools />;
  }

  if (provider === "lambdalabs") {
    return <LambdalabsNodePools />;
  }

  if (provider === "linode") {
    return <LinodeNodePools />;
  }

  if (provider === "oblivus") {
    return <OblivusNodePools />;
  }

  if (provider === "paperspace") {
    return <PaperspaceNodePools />;
  }

  if (provider === "triton") {
    return <TritonNodePools />;
  }

  return null;
};
